exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gwnl-pager[data-v-61bf4106]{float:right;margin-top:16px}\n", ""]);

